/* Plainly: small enhancements on top of Dawn. No dependencies. */
(function () {
  'use strict';

  /* ---------- Delivery estimate ----------
     Counts business days (Mon to Fri) from today and fills in the dates.
     Markup: <p class="p-delivery" data-min="3" data-max="8" data-template="...[start]...[end]..."> */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString().slice(4, 10);
    }
  }

  function renderDelivery(root) {
    (root || document).querySelectorAll('.p-delivery[data-template]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 3;
      var max = parseInt(el.dataset.max, 10) || 8;
      var today = new Date();
      var start = formatDate(addBusinessDays(today, min));
      var end = formatDate(addBusinessDays(today, max));
      var target = el.querySelector('[data-delivery-text]');
      if (!target) return;
      target.innerHTML = el.dataset.template
        .replace('[start]', '<strong>' + start + '</strong>')
        .replace('[end]', '<strong>' + end + '</strong>');
      el.hidden = false;
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-p-sticky-atc]');
    if (!bar) return;

    var mainButton = document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
    if (!mainButton) return;

    var barButton = bar.querySelector('[data-p-sticky-button]');
    var barButtonText = bar.querySelector('[data-p-sticky-button-text]');
    var barVariant = bar.querySelector('[data-p-sticky-variant]');
    var barPrice = bar.querySelector('[data-p-sticky-price]');

    function currentMainButton() {
      return document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
    }

    function sync() {
      var btn = currentMainButton();
      if (!btn) return;
      var label = btn.querySelector('span');
      if (barButtonText && label) barButtonText.textContent = label.textContent.trim();
      if (barButton) barButton.disabled = btn.disabled;

      var price = document.querySelector('.product__info-container .price');
      if (barPrice && price) {
        var sale = price.classList.contains('price--on-sale');
        var shown = sale
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item--regular');
        if (shown) barPrice.textContent = shown.textContent.trim();
      }

      if (barVariant) {
        var picked = [];
        document.querySelectorAll('.product__info-container variant-selects fieldset, .product__info-container variant-selects .product-form__input--dropdown').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          var select = group.querySelector('select');
          if (checked) picked.push(checked.value);
          else if (select) picked.push(select.value);
        });
        barVariant.textContent = picked.join(' / ');
        barVariant.hidden = picked.length === 0;
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var pastIt = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', pastIt);
            bar.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
            if (barButton) barButton.tabIndex = pastIt ? 0 : -1;
          });
        },
        { threshold: 0 }
      );
      observer.observe(mainButton);

      /* Dawn swaps the product form HTML on variant change, so watch for that. */
      var info = document.querySelector('product-info') || document.querySelector('.product__info-container');
      if (info && 'MutationObserver' in window) {
        new MutationObserver(function () {
          var btn = currentMainButton();
          if (btn && btn !== mainButton) {
            observer.unobserve(mainButton);
            mainButton = btn;
            observer.observe(mainButton);
          }
          sync();
        }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      }
    }

    if (barButton) {
      barButton.addEventListener('click', function () {
        var btn = currentMainButton();
        if (btn && !btn.disabled) btn.click();
      });
    }

    sync();
  }

  /* ---------- Buy 2, get 1 free progress (cart drawer and cart page) ----------
     Display only. Settings come from the "Plainly settings" section in the header. */
  var dealConfig = null;
  var dealCount = null;

  function readDealConfig() {
    var el = document.getElementById('PlainlyConfig');
    if (!el || el.dataset.dealEnabled !== 'true') return null;
    return {
      threshold: parseInt(el.dataset.dealThreshold, 10) || 3,
      progress: el.dataset.dealProgress || '',
      unlocked: el.dataset.dealUnlocked || '',
      count: parseInt(el.dataset.cartCount, 10) || 0
    };
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function dealHtml(count) {
    var t = dealConfig.threshold;
    var inSet = count % t;
    var setsDone = Math.floor(count / t);
    var filled = inSet === 0 ? t : inSet;
    var message;
    if (inSet === 0) {
      message = escapeHtml(dealConfig.unlocked);
    } else {
      message = escapeHtml(dealConfig.progress).replace('[count]', '<strong>' + (t - inSet) + '</strong>');
      if (setsDone > 0) message = escapeHtml(dealConfig.unlocked) + ' ' + message;
    }
    var bars = '';
    for (var i = 1; i <= t; i++) bars += '<span' + (i <= filled ? ' class="is-on"' : '') + '></span>';
    return '<p>' + message + '</p><div class="p-deal-progress__bar" style="--steps:' + t + '" aria-hidden="true">' + bars + '</div>';
  }

  function placeDeal() {
    if (!dealConfig || dealCount === null) return;
    var targets = [];
    var drawerHeader = document.querySelector('#CartDrawer .drawer__header');
    if (drawerHeader) targets.push({ anchor: drawerHeader, where: 'afterend' });
    var cartPage = document.querySelector('#main-cart-items .js-contents');
    if (cartPage) targets.push({ anchor: cartPage, where: 'afterbegin' });

    targets.forEach(function (t) {
      var scope = t.where === 'afterend' ? t.anchor.parentNode : t.anchor;
      var box = scope.querySelector(':scope > .p-deal-progress');
      if (dealCount === 0) {
        if (box) box.remove();
        return;
      }
      var html = dealHtml(dealCount);
      if (!box) {
        box = document.createElement('div');
        box.className = 'p-deal-progress';
        box.setAttribute('role', 'status');
        t.anchor.insertAdjacentElement(t.where, box);
      }
      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }

  var dealFetchTimer = null;
  function refreshDeal() {
    clearTimeout(dealFetchTimer);
    dealFetchTimer = setTimeout(function () {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          dealCount = cart.item_count || 0;
          placeDeal();
        })
        .catch(function () {});
    }, 150);
  }

  function initDeal() {
    dealConfig = readDealConfig();
    if (!dealConfig) return;
    dealCount = dealConfig.count;
    placeDeal();

    /* Dawn replaces the drawer and cart contents after every change, so put the bar back each time. */
    ['cart-drawer', 'cart-items'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(function (el) {
        new MutationObserver(function (mutations) {
          var ours = mutations.every(function (m) {
            return m.target.closest && m.target.closest('.p-deal-progress');
          });
          if (!ours) refreshDeal();
        }).observe(el, { childList: true, subtree: true });
      });
    });
  }

  /* ---------- "% off" on Dawn's product cards (collection pages, related products) ---------- */
  function toNumber(text) {
    var n = parseFloat(String(text).replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function labelCardDiscounts(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      var badge = card.querySelector('.card__badge .badge');
      var price = card.querySelector('.price--on-sale');
      if (!badge || !price) return;
      var was = toNumber((price.querySelector('.price__sale .price-item--regular') || {}).textContent);
      var now = toNumber((price.querySelector('.price__sale .price-item--sale') || {}).textContent);
      if (!was || !now || now >= was) return;
      badge.textContent = Math.round(((was - now) / was) * 100) + '% off';
      badge.classList.add('price__badge-sale');
    });
  }

  function init() {
    labelCardDiscounts();
    renderDelivery();
    initStickyAtc();
    initDeal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    renderDelivery(e.target);
    labelCardDiscounts(e.target);
  });

  /* Related products load after the page, so label them when they arrive */
  if ('MutationObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('product-recommendations').forEach(function (el) {
        new MutationObserver(function () {
          labelCardDiscounts(el);
        }).observe(el, { childList: true });
      });
    });
  }
})();
